import { useEffect, useState } from 'react'
import { ITireRackOrder } from '../../../../../app/entities/TireRackOrder'
import createTrackingLinks from '../../utils/tire-rack-order/create-tracking-links'
import TrackingLinksModal from '../cards/technician/technician-route-card/tracking-links/TrackingLinksModal'

interface TrackItProps {
  orderObjectId: string
  tireRackOrders: ITireRackOrder[]
  newTabTrackItId?: string
  multiLinkTrackItId?: string
}

const TRACK_IT_STR = 'track it'

export default function TrackIt(props: TrackItProps) {
  const { multiLinkTrackItId, newTabTrackItId, tireRackOrders } = props

  const allTrackingLinks: string[] = []
  const allTrackingNumbers: string[] = []

  tireRackOrders.forEach((tro) => {
    const { trackingLinks, trackingNumbers } = createTrackingLinks(tro)
    allTrackingLinks.push(...trackingLinks)
    allTrackingNumbers.push(...trackingNumbers)
  })

  const trackingInfo = {
    trackingNumbers: allTrackingNumbers,
    trackingLinks: allTrackingLinks,
  }

  const newTabTrackingLinkElementId = newTabTrackItId ?? 'newTabTrackingLink'
  const multiLinkTrackingLinkElementId =
    multiLinkTrackItId ?? 'multiLinkTrackingLink'

  const [modalOpen, setModalOpen] = useState(false)
  function handleClosed() {
    setModalOpen(false)
  }

  function generateTrackItLink(): JSX.Element {
    if (!allTrackingLinks || allTrackingLinks.length <= 0) {
      return <div />
    } else if (allTrackingLinks.length === 1) {
      return (
        <a
          href={allTrackingLinks[0]}
          target='_blank'
          rel='noreferrer'
          id={newTabTrackingLinkElementId}
        >
          {TRACK_IT_STR}
        </a>
      )
    } else {
      // if there are multiple tracking links, we know that we need to
      // open a modal to display them
      return (
        <a
          href='#'
          id={multiLinkTrackingLinkElementId}
        >
          {TRACK_IT_STR}
        </a>
      )
    }
  }

  // prevent work orders detail modal from opening when clicking on tracking links
  useEffect(() => {
    const ontracTrackingLink = document.getElementById(
      multiLinkTrackingLinkElementId,
    )
    const newTabTrackingLink = document.getElementById(
      newTabTrackingLinkElementId,
    )
    if (ontracTrackingLink) {
      ontracTrackingLink.addEventListener('click', function (e) {
        setModalOpen(true)

        e.stopPropagation()
      })
    }
    if (newTabTrackingLink) {
      newTabTrackingLink.addEventListener('click', function (e) {
        e.stopPropagation()
      })
    }
  }, [allTrackingLinks])

  return (
    <div>
      <TrackingLinksModal
        trackingInfo={trackingInfo}
        isOpen={modalOpen}
        handleClosed={handleClosed}
      />
      {generateTrackItLink()}
    </div>
  )
}
